import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { NeoParametrizacionLineaDTO } from '../../Model/neoParametrizacionLineaDTO';
import { ParametrizacionLineaService } from '../../Service/parametrizacion-linea.service';
import { AlertService } from '../../../services/alert.service';
import { UserService } from '../../../services/user.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';

@Component({
    selector: 'app-administracion-lineas-credito',
    templateUrl: './administracion-lineas-credito.component.html',
    styleUrls: ['./administracion-lineas-credito.component.scss'],
    standalone: false
})
export class AdministracionLineasCreditoComponent implements OnInit {
  // Observable lineas de credito
  lineasCredito: Observable<NeoParametrizacionLineaDTO[]>;
  //
  idNeoCliente: any = 0;
  constructor(
    protected parametrizacionLineaService: ParametrizacionLineaService,
    protected userIntermediarioService: UserService,
    private alertService: AlertService,
    private _sweetAlert:SweetAlertService
  ) {}

  ngOnInit(): void {
    this.cargarIdNeoCliente();
    this.getLineasDeCreditoPorIdNeoCliente();
  }
  cargarIdNeoCliente() {
    this.idNeoCliente = this.userIntermediarioService.getUser().idCliente;
  }
  getLineasDeCreditoPorIdNeoCliente() {
    this.lineasCredito =
      this.parametrizacionLineaService.getParametrizacionesLineaPorIdCliente(
        this.idNeoCliente
      );
  }

  deleteLineaDeCredito(idParametrizacionLinea: Number) {
    this.parametrizacionLineaService
      .deleteParametrizacionLinea(idParametrizacionLinea)
      .subscribe(() => {
        this._sweetAlert.successModal("Éxito!",false,"Línea de crédito eliminada exitosamente");
        this.getLineasDeCreditoPorIdNeoCliente();
      });
  }
}
